export default {
  async mounted() {
    const id = await this.$store.dispatch("getOpenSupervision");
    if (id) {
      this.$router.push(`/ticker/${id}`);
    }
    else {
      if (this.$route.name === "ticker" || this.$route.name === "default") {
        this.$router.push(`/select-roles`);
      }
    }
  }
}